import { Cell, CellProps } from 'react-aria-components'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type TableCellProperties = CellProps & {
    className?: string
}

export const TableCell = ({
    className,
    ...properties
}: Readonly<TableCellProperties>) => {
    return (
        <Cell
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
